import  { FC, useRef, useState } from "react";
import Cropper from "react-cropper";
import Button from "Components/Button";
import "cropperjs/dist/cropper.css";
import { Wrapper, ButtonWrapper } from "./ImageCropper.styled";

type Props = {
  setCropData: any;
  files: {
    preview: string;
  }[];
  setFiles: any;
};

const ImageCropper: FC<Props> = ({ setCropData, files, setFiles }) => {

  const [cropper, setCropper] = useState<any>();
  const handleCancelCrop = () => {
    setFiles([]);
  };

  const cropperRef = useRef<HTMLImageElement>(null);
  const onCrop = () => {
    const reader = new FileReader();
    reader.onload = () => {};
  };
  const getCropData = () => {
    if (typeof cropper !== "undefined") {
      cropper.getCroppedCanvas().toBlob((blob: any) => setCropData(blob));
      setFiles([]);
    }
  };
  if (!files[0]) {
    return null;
  }
  return (
    <>
      <Cropper
        ref={cropperRef}
        src={files[0].preview}
        guides={false}
        crop={onCrop}
        style={{ height: 200, width: "100%" }}
        onInitialized={(instance) => {
          setCropper(instance);
        }}
      />
      <Wrapper>
        <ButtonWrapper>
          <span>
            <Button handleClick={handleCancelCrop} buttonStyles="secondary" className="ghost-btn">
              Cancel
            </Button>
            <Button handleClick={getCropData} buttonStyles="primary">
              Crop
            </Button>
          </span>
        </ButtonWrapper>
      </Wrapper>
    </>
  );
};

export default ImageCropper;
